import { render, staticRenderFns } from "./FooterInfoContact.vue?vue&type=template&id=07fd6859&scoped=true&"
import script from "./FooterInfoContact.vue?vue&type=script&lang=js&"
export * from "./FooterInfoContact.vue?vue&type=script&lang=js&"
import style0 from "./FooterInfoContact.vue?vue&type=style&index=0&id=07fd6859&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fd6859",
  null
  
)

export default component.exports